module.exports = __webpack_public_path__ + "media/images/partner-16-dc4de5de52881d43046302e5fc82c2c0.png";